import React, { useState, useEffect } from 'react';
import IconButton from '#components/controls/icon-button/IconButton';
import ChevronUp from '#components/icons/ChevronUp';
import styles from './ScrollToTop.module.css';

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      const isScrolledDown = scrollPosition > 200;
      const isScrolledToFooter =
        scrollPosition + window.innerHeight >=
        document.documentElement.scrollHeight - 120;
      setIsVisible(isScrolledDown && !isScrolledToFooter);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <IconButton
      classes={`${styles.scrollButton} ${isVisible ? styles.visible : ''}`}
      onClick={scrollToTop}
      size="xlarge"
    >
      <ChevronUp />
    </IconButton>
  );
};

export default ScrollToTopButton;
